import { render, staticRenderFns } from "./Tab10ListOfParticipants.vue?vue&type=template&id=75a48012&scoped=true"
import script from "./Tab10ListOfParticipants.vue?vue&type=script&lang=js"
export * from "./Tab10ListOfParticipants.vue?vue&type=script&lang=js"
import style0 from "./Tab10ListOfParticipants.vue?vue&type=style&index=0&id=75a48012&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a48012",
  null
  
)

export default component.exports